import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Home, Activity, FileText, User, LogOut } from 'lucide-react';
import { DashboardHeader } from './dashboard/DashboardHeader';
import { useAuth } from '../contexts/AuthContext';
export function AppLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    logout
  } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  const navItems = [{
    to: '/app',
    icon: Home,
    label: 'Home'
  }, {
    to: '/app/legal-health-check',
    icon: Activity,
    label: 'Legal Health Check'
  }, {
    to: '/app/reports',
    icon: FileText,
    label: 'Reports'
  }, {
    to: '/app/profile',
    icon: User,
    label: 'Profile'
  }];
  return <div className="min-h-screen bg-aliceBlue flex flex-col" data-id="element-51">
      <DashboardHeader data-id="element-52" />

      <nav className="bg-white border-b border-borderColor" data-id="element-53">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
          <div className="flex items-center justify-between" data-id="element-55">
            <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide -mb-px" data-id="element-56">
              {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/app'} className={({
              isActive
            }) => `flex items-center gap-2 px-4 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${isActive ? 'border-violetBlue text-violetBlue' : 'border-transparent text-secondary hover:text-primary hover:border-borderColor'}`} data-id="element-57">
                  <item.icon className="w-4 h-4" data-id="element-58" />
                  <span className="hidden sm:inline" data-id="element-59">{item.label}</span>
                </NavLink>)}
            </div>
            <button onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-sm text-secondary hover:text-primary transition-colors" title="Log Out" data-id="element-60">
              <LogOut className="w-4 h-4" data-id="element-61" />
              <span className="hidden md:inline" data-id="element-62">Log Out</span>
            </button>
          </div>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-63">{children}</main>
    </div>;
}